<fieldset>
	<br />
	<app-cycle-mixture-row 
		*ngFor="let mortgage of cycleMixureFormArray.controls; let i=index" 
		[index]=i 
		(removed)="cycleMixureFormArray.removeAt($event)"
		[rowData]="mortgage"
		(change)="emitChanges($event)"
		[displayErrors]="displayErrors">
	</app-cycle-mixture-row>
</fieldset>

<div class="d-flex justify-content-center text-center">
	<div *ngIf="cycleMixureFormArray.length > 0 && cycleMixureFormArray.length < maxArrayLength" class="m-add-line-btn"
		role="button" tabindex="0" (keypress)="simulateClick($event)" (click)="addrow()">
		<span>{{'CYCLE_MIXTURE.ADD'|translate}}</span>
	</div>

	<div *ngIf="cycleMixureFormArray.length === 0" class="m-add-line-btn" (click)="addrow()" role="button" tabindex="0"
		(keypress)="simulateClick($event)">
		<i class="fa fa-plus" aria-hidden="true"></i>
		<span>{{'CYCLE_MIXTURE.ADD'|translate}}</span>
	</div>
</div>
<br />


// WEBPACK FOOTER //
// ./src/app/cycle-mixture/cycle-mixture.component.html